import QuestionnaireAPI from './QuestionnaireAPI';
import TargetingAPI from './TargetingAPI';
import PeeqTargetingAPI from './PeeqTargetingAPI';

class TemplateSurveyState {
  constructor({ fetchedQuestionnaire, fetchedTargeting } = {}) {
    this.questionnaire = new QuestionnaireAPI(fetchedQuestionnaire);
    if (fetchedTargeting) {
      if (fetchedTargeting.surveyType === 9) {
        this.targeting = new PeeqTargetingAPI(fetchedTargeting);
      } else {
        this.targeting = new TargetingAPI(fetchedTargeting);
      }
    }
  }

  get state() {
    return {
      questionnairePage: this.questionnaire?.state,
      targetingPage: this.targeting?.state,
    };
  }
}

export default TemplateSurveyState;
